(() => {
  setTimeout(() => {
    handleQuickView();
  }, 1000)
})();

function handleQuickView(){
  const targetNode = document.querySelector('.quick-product-modal__content');

  if (targetNode) {
    const observer = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        if (
          mutation.type === 'attributes' &&
          mutation.attributeName === 'class'
        ) {
          document.dispatchEvent(new Event(`bss_b2b:QuickviewLoaded`))
        }
      }
    });
  
    const config = {
      attributes: true,
      attributeFilter: ['class'], 
    };
  
    observer.observe(targetNode, config);
  }
}